<template>
    <body class="bg-gray-50 text-gray-800">
        <!--<header class="bg-white border-b border-gray-300 py-4">
            <div class="container mx-auto px-4 flex items-center">
                <div class="flex items-center space-x-4">
                    <img src="../../../public/usllogo.5f869bb1.png" alt="US Legal Services Logo" class="w-25 h-12">
                    <div>
                        <h1 class="text-xl font-bold text-gray-900">U.S. Legal Services</h1>
                        <p class="text-gray-700 text-sm">Est. 1974</p>
                    </div>
                </div>
            </div>
        </header>-->

        <main class="container mx-auto px-4 py-8">
            <h1 class="text-2xl font-bold text-center text-gray-900 mb-6" style="color: #1f3341">2025 Fee for Services Network Attorney Agreement</h1>

            <section class="bg-white rounded-lg shadow-md p-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Agreement Overview</h2>
                <p class="mt-4">This Fee for Services Network Attorney Agreement (“Agreement”) is entered into between U.S. Legal Services, Inc., [hereinafter “USL”] and the Applicant Attorney, effective upon the date signed by the parties to this Agreement.</p>
            </section>

            <section class="bg-white rounded-lg shadow-md p-6 mt-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Definitions</h2>
                <p>Definitions as used in the Agreement and its addendums:</p>
                <ul class="list-disc pl-6 space-y-2 mt-4">
                    <li><strong>"Covered"</strong>: Means personal legal services for a Plan Member that are paid either partially or in full by USL under a legal plan.</li>
                    <li><strong>"Referral"</strong>: Means personal legal services for which coverage is not paid by USL and is billed directly to the Member at a discounted rate.</li>
                    <li><strong>"Plan Member"</strong>: A person who is entitled to Covered or Referral legal services under a legal plan or an insurance policy administered by USL or an affiliate.</li>
                    <li><strong>"Network Attorney"</strong>: Means an attorney who:
                        <ol class="pl-6 space-y-1">
                            <li class="before:content-['(a)'] before:mr-2">Is an active member of their State Bar in good standing.</li>
                            <li class="before:content-['(b)'] before:mr-2">Maintains a law office and is regularly engaged in the practice of law.</li>
                            <li class="before:content-['(c)'] before:mr-2">Maintains insurance coverage under a professional liability policy providing limits of not less than $100,000 per incident and $300,000 aggregate per year.</li>
                            <li class="before:content-['(d)'] before:mr-2">Has agreed to accept Covered legal matters noted on their USL profile.</li>
                            <li class="before:content-['(e)'] before:mr-2">Provides at least a 33.3% reduction on attorney's normal rates for non-excluded, Referral legal matters.</li>
                            <li class="before:content-['(f)'] before:mr-2">Provides a free initial consultation to all Plan Members on Referral legal matters.</li>
                            <li class="before:content-['(g)'] before:mr-2">Completes and delivers a USL signed Application.</li>
                            <li class="before:content-['(h)'] before:mr-2">Is accepted as a Network Attorney by USL.</li>
                        </ol>
                    </li>
                    <li><strong>"State Bar"</strong>: Includes the attorney regulatory body of any jurisdiction in which the attorney maintains an office for the practice of law.</li>
                </ul>
            </section>

            <section class="bg-white rounded-lg shadow-md p-6 mt-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Section 1. Obligations of a Network Attorney</h2>
                <h3 class="text-lg font-semibold text-gray-800 mt-4">A. Notification of Change of Information or Status</h3>
                <p class="mt-2">Network Attorney agrees to promptly notify USL of any change of address, telephone number, e-mail address, or any change of actual or impending circumstances that might affect his/her status as an attorney, including but not limited to, any lapse in the required insurance coverage, any change in the attorney’s licensing or State Bar standing, and any complaints filed with a disciplinary committee or State Bar of any state or province. Network Attorney agrees to update his/her USL profile from time to time so that it accurately reflects the legal matters, whether Covered or Referral, that he/she will accept.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">B. Representation</h3>
                <p class="mt-2">Network Attorney agrees to provide services to Plan Member(s) in accordance with terms of the U.S. Legal Services, Inc. Application, Fee for Services Network Attorney Agreement, Participating Network Attorney Fee Reimbursement Schedule and Plan Descriptions, including any Limitations or Exclusions, and any subsequent revisions thereof. Network Attorney acknowledges that while performing under this Agreement he/she will have access to and/or be in possession of confidential information in the form of the Participating Network Attorney Fee Reimbursement Schedule solely for the purpose of performing Network Attorney's services hereunder, and agrees to refrain from the disclosure of the contents of such confidential information to the Plan Members or any other party other than the agents and/or employees of the Network Attorney and USL.</p>

                <p class="mt-2">A Network Attorney may decline representation of a Plan Member on reasonable grounds. If Network Attorney declines representation of an eligible Plan Member, Network Attorney agrees agree to notify USL of the reason for the declination to facilitate attorney reassignment and to ensure the Plan Member’s ability to derive benefits under the Plan. If a Network Attorney does not feel he/she has the expertise required to assist a Plan Member or feels that assignment to another attorney is necessary to best serve the interests of the Plan Member, Network Attorney must advise the Plan Member to call USL regarding their coverage rather than referring the Plan Member to another attorney.</p>

                <p class="mt-2">Network Attorney is not to accept representation regarding any actions, proceeding, dispute, or any matter against: USL, the policyholder, the Plan Member’s employer, the Plan Member’s employee benefit plan providers or any vendor providing services to Plan Member's employer-provided benefit plan regardless of who is paying for that representation.</p>

                <p class="mt-2">Network Attorney agrees to defend, indemnify and hold USL and Plan Sponsors harmless from any and all liability or alleged liability which may arise out of the acts or omissions of the Network Attorney in the performance of services and carrying out his/her obligations to Plan Members. “Liability” shall include, without limitation, any and all costs and expenses incurred, including reasonable attorney’s fees and court costs. “Alleged Liability” shall include any and all claims and demands.</p>

                <p class="mt-2">Neither USL nor any other third party shall interfere with or control the performance of the duties of Network Attorney to the Plan Member.</p>
            </section>

            <section class="bg-white rounded-lg shadow-md p-6 mt-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Section 2. Legal Service Fees</h2>
                <h3 class="text-lg font-semibold text-gray-800 mt-4">A. Payments for Covered Services</h3>
                <p class="mt-2">Each Network Attorney agrees to accept the amounts listed in the Participating Network Attorney Fee Reimbursement Schedule as payment in full for Covered services to Plan Members and shall make no additional charges to the Plan Member for attorney’s fees unless the plan description allows. All out-of-pocket expenses such as filing fees, court costs, court reporters’ fees, and other miscellaneous costs in any proceeding are the responsibility of the Plan Member, and a Network Attorney is entitled to collect any such funds directly from the Plan Member. Covered services may not be combined for any one matter to increase maximum fees. Network Attorneys who provide Covered services under the program shall be paid directly by USL upon submission of claims in acceptable form, subject to the terms of this Agreement and the applicable Fee Reimbursement Schedule.</p>

                <p class="mt-2">Network Attorneys agree to contact U.S. Legal Services to ascertain the plan benefits available to each Plan Member and obtain the appropriate authorization prior to providing legal services. Additionally, Network Attorneys agree to submit claims not more than ninety [90] days following the completion of any legal matter for which services have been rendered. Network Attorneys agree to maintain appropriate Plan Member records concerning the subject on which advice was given or representation offered or provided, the dates, times, and length of time spent by the Network Attorney in any conferences, hearings, or other actions taken or performed in providing advice or representation, the disposition of the matter, and any charges made to the eligible Plan Member for legal services other than Covered services. Network Attorneys agree to make such records available to USL upon request as supporting documentation for claims submitted.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">B. Payment for Referral Services [“Referral”]</h3>
                <p class="mt-2">Each Network Attorney shall provide Referral legal services under the program with a free initial consultation and at least a 33.3% discount from his/her normal hourly or flat fee rates for the required services. The Network Attorney agrees to cooperate with USL by providing information on his/her normal rates for the legal services to be provided by the attorney. Network Attorneys who provide services under the reduced rate program shall be paid directly by the Plan Member. USL will not be responsible for any fees for Referral services or their collection from Plan Member.
                </p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">C. Fee Agreement</h3>
                <p class="mt-2">This Agreement takes precedence over any other fee agreement between the Network Attorney and Plan Member. Network Attorney agrees to provide USL Plan Members with a written fee agreement for Referral matters. Under
                no circumstances shall a Network Attorney seek additional payment from a Plan Member for Covered services that are provided under a USL plan or policy on a paid-in-full basis.
                </p>
            </section>

            <section class="bg-white rounded-lg shadow-md p-6 mt-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Section 3. Additional Terms</h2>
                <h3 class="text-lg font-semibold text-gray-800 mt-4">A. Termination</h3>
                <p class="mt-2">An attorney’s status as a Network Attorney maybe altered by resignation, inactivation or termination at any time by the Attorney or by USL with thirty [30] days written notice. USL reserves the right to inactivate or terminate a Network Attorney at any time for reasonable cause. In the event of inactivation or termination, the Network Attorney will still be bound by the obligations specified in this Agreement with respect to completion of legal services undertaken before inactivation, termination or resignation and payment for such services.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">B. Amendment</h3>
                <p class="mt-2">This Agreement, the Participating Network Attorney Fee Reimbursement Schedule, specific Policy Limitations and/or Exclusions and Plan Descriptions incorporated herein are subject to revocation, amendment or other modification
                at any time by USL, but any such revocation, amendment or modification shall not diminish or reduce the rights accrued or obligations incurred prior thereto.
                </p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">C. Arbitration</h3>
                <p class="mt-2">Any dispute or disagreement arising out of the interpretation of this Agreement or out of the transactions covered by this Agreement shall be submitted to binding arbitration in accordance with the Arbitration Rules of the American
                Arbitration Association as shall be in effect at the time of such dispute. Such arbitration will be held in Jacksonville, Duval County, Florida unless a mutually agreed upon alternate site is selected.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">D. Non-Waiver</h3>
                <p class="mt-2">The failure of either party to enforce strict compliance with this Agreement, in whole or in part, or to exercise any right hereunder, shall not constitute a waiver of any rights herein contained and shall not be held to constitute a course of conduct or waiver of a subsequent breach of that or any other provision.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">E. Effect of Invalid or Unenforceable Provision</h3>
                <p class="mt-2">If any provision of this Agreement is held to be invalid or unenforceable by reason of conflict with applicable law or regulation, the Agreement will be considered amended to the minimum extent necessary to give effect to the balance of the Agreement as if the offending provision(s) were not present.</p>

                <h3 class="text-lg font-semibold text-gray-800 mt-4">F. Governance</h3>
                <p class="mt-2">This Agreement has been entered into and shall be governed for all matters concerning validity, performance and interpretation under the laws of the State of Florida.</p>
            </section>


            <section class="bg-white rounded-lg shadow-md p-6 mt-6">
                <h2 class="text-xl font-semibold text-[#1f3341]">Attorney's Certification</h2>
                <div class="mb-4 flex items-center">
                    <a href="https://uslpublicresources.s3.us-east-1.amazonaws.com/policy_files/USL+Fee+Reimbursement+Schedule+-+Standard.pdf"
                download="USL_Fee_Reimbursement_Schedule_2025.pdf" target="_blank" class="text-blue-600 hover:text-blue-800 flex items-center underline">
                        <i class="fa fa-file-pdf-o text-red-600 mr-2"></i> Click here to view and download the 2025 Fee Schedule.
                    </a>
                </div>
                <form @submit.prevent="handleSubmit" class="mt-4">
                    <div class="flex items-start mb-4">
                        <input id="certification" name="certification" type="checkbox" v-model="form.certification" @blur="v$.form.certification.$touch()" class="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                        <label for="certification" class="ml-3 text-sm text-gray-800">
                            I agree to the terms of the USL Fee for Services Network Attorney Agreement, Participating Network Attorney Fee       Reimbursement Schedule, Plan Descriptions, Specific Plan and Policy Limitations and/or Exclusions, and any subsequent revisions thereof.
                        </label>
                    </div>
                    <p v-if="submitted && v.certification.$invalid" class="text-red-600 text-sm mb-2">
                        {{ v.certification.$errors[0]?.$message || 'You must agree to the terms.' }}
                        </p>
                    <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                        <p class="mb-2"><b>I understand that typing my name and submitting this form is the legal equivalent of having placed my handwritten signature on the submitted form and this attestation. I understand and agree that by electronically signing and submitting this form I am affirming the truth of the information contained therein.</b></p>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <input type="text" id="attorney-name"  v-model="form.attorneyName" name="attorney-name" placeholder="Please type your full name here" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"  @blur="v$.form.attorneyName.$touch()" autocomplete="off">
                            <label for="attorney-name" class="block text-sm font-medium text-gray-700 mt-2">Attorney Name</label>
                            <p v-if="submitted && v.attorneyName.$invalid" class="text-red-600 text-sm">
                            {{ v.attorneyName.$errors[0]?.$message || 'This field is required.' }}
                            </p>
                        </div>
                        <div>
                            <input type="text" id="date" name="date" placeholder="MM/DD/YYYY" v-model="form.date" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" disabled @blur="v$.form.date.$touch()" autocomplete="off">
                            <label for="date" class="block text-sm font-medium text-gray-700 mt-2">Date</label>
                            <p v-if="submitted && v.date.$invalid" class="text-red-600 text-sm">
                            {{ v.date.$errors[0]?.$message || 'This field is required.' }}
                            </p>

                        </div>
                    </div>
                    <button :disabled="loading" type="submit" class="mt-6 w-full sm:w-auto px-6 py-2 bg-[#ce4c29] text-white font-medium text-sm rounded-md shadow hover:bg-[#ce4c29] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-75 disabled:bg-[#ce4c29] disabled:cursor-not-allowed">
                        <span v-if="loading">Submitting...</span>
                        <span v-else>Submit</span>
                    </button>
                </form>
                <div v-if="loading" class="spinner"></div>
            </section>
        </main>

        <!-- <footer class="bg-gray-800 text-white py-4">
            <div class="container mx-auto px-4 text-center">
                <p class="text-sm">&copy; 2025 U.S. Legal Services. All rights reserved.</p>
            </div>
        </footer> -->
    </body>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import {ref, reactive, onMounted  } from 'vue'
import { helpers } from '@vuelidate/validators'
import { computed } from 'vue';
import { useRoute,useRouter  } from 'vue-router';
import CryptoJS from 'crypto-js';
import Constants from '../../constants.ts'

const loading = ref(false)
export default {
    mounted() {
        const sig = this.$route.query.sig;
        const userId = this.$route.params.attid;
        const dataToSign = `attid=${userId}`;


        const expectedSig = CryptoJS.HmacSHA256(dataToSign, this.SECRET_KEY).toString(CryptoJS.enc.Hex);

        if (sig !== expectedSig) {
            Swal.fire({
                title: 'Invalid Link',
                text: "This link isn't working or might have been changed.",
                icon: 'error',
            }).then(() => {
                // Redirect or disable form
                this.$router.replace('/');
            });
        }
    },
  name: "NewFeeSchedule",
  data() {
    return {
        SECRET_KEY:Constants.SECRET_KEY,
        SELECTED_TRUE: Constants.SELECTED_TRUE,
        GENERATE_TOKEN: Constants.GENERATE_TOKEN,
        START_STATE_MACHINE: Constants.START_STATE_MACHINE
    }
  },

  setup() {
    /* global Swal */
    const route = useRoute();
    const router = useRouter();
    const submitted = ref(false);
    const  SELECTED_TRUE= Constants.SELECTED_TRUE;
    const  GENERATE_TOKEN= Constants.GENERATE_TOKEN;
    const  START_STATE_MACHINE= Constants.START_STATE_MACHINE
    
    const form = reactive({
        certification: '',
        attorneyName: '',
        date: ''
    });
    // const isTrue = helpers.withMessage(
    // 'You must agree to the terms.',
    // value => value === true
    // );

    const notInFuture = helpers.withMessage('Date cannot be in the future.', value => {
        if (!value) return true
        const today = new Date()
        const inputDate = new Date(value)
        today.setHours(0, 0, 0, 0)
        inputDate.setHours(0, 0, 0, 0)
        return inputDate <= today
    })

    const validations = {
        form: {
            certification: {
            // required: helpers.withMessage('You must agree to the terms.', required),
            isTrue: helpers.withMessage('You must agree to the terms.', value => value === true)
            },
            attorneyName: {
            required: helpers.withMessage('Attorney name is required.', required),
            },
            date: {
            required: helpers.withMessage('Date is required.', required),
            notInFuture
            }
        }
    };

    const v$ = useVuelidate(validations, { form });
    const v = computed(() => v$.value.form);

    onMounted(() => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        form.date = `${mm}/${dd}/${yyyy}`;
    });

    const handleSubmit = async () => {
      submitted.value = true;
      v$.value.$touch();
      await v$.value.$validate();
      if (v$.value.$error) {
        
        console.log("Form is invalid");
        // v$.value.$reset();
        // submitted.value = false;
        return;
      }
      const attid = route.params.attid;
      loading.value = true;

      try {
        const checkResponse = await fetch(SELECTED_TRUE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attid }),
        });

        const checkData = await checkResponse.json();

        if (checkData.hasSelectedTrue) {
            Swal.fire({
            title: 'Already Submitted',
            text: 'You have already submitted the agreement form.',
            icon: 'info',
            });
            form.certification = false;
            form.attorneyName = '';
            // form.date = '';
            submitted.value = false;
            loading.value = false;
            return;
        }
        const tokenResponse = await fetch(GENERATE_TOKEN, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            attid: attid,
            selected: true,
            userId: "uslenroll11!!"
          })
        });
        
        const tokenData = await tokenResponse.json();

        if (!tokenResponse.ok || !tokenData.data) {
            throw new Error('Failed to generate token');
        }

        const token = tokenData.data;
        
        const response = await fetch(START_STATE_MACHINE, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': 'NDAzYjdjMTctMTQ3NS00NDMyLWI4OWYtZjlkNjljOGZmNWQ3NjM3NTczNDI0MTAwMjI2Mjg1',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            attid: attid,
            selected: true,
            userId: "uslenroll11!!",
            date: form.date,
            attorneyName: form.attorneyName
          })
        });

        const result = await response.json();
        console.log("result",result);
        
        console.log('Status updated:', result);
      } catch (error) {
        console.error('Error updating status:', error);
      }
      form.certification = false;
      form.attorneyName = '';
    //   form.date = '';
      v$.value.$reset();
      submitted.value = false;
      loading.value = false;
      console.log("Form submitted successfully", form);
      await router.push('/thank-you'); 
    };

    return {
      form,
      v$,
      submitted,
      handleSubmit,
      v,
      loading
    };
  }
};
</script>


<style>
.spinner {
  margin: 20px auto;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #1f3341;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>